class AnimatedStats extends window.BAO.CustomElement() {
  static get observedAttributes () {
    return ['data-duration']
  }

  constructor () {
    super()

    this.isAnimated = false
    this.onEntry = this.onEntry.bind(this)
  }

  connectedCallback () {
    super.connectedCallback()

    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(this.onEntry)
      },
      {
        threshold: 0.2,
      },
    )

    this.observer.observe(this)
  }

  disconnectedCallback () {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  onEntry (entry) {
    if (entry.isIntersecting) {
      if (!this.isAnimated) {
        this.animateStats()
        this.isAnimated = true
      }
    } else {
      this.resetStats()
      this.isAnimated = false
    }
  }

  resetStats () {
    this.els.value.elements.forEach(stat => {
      stat.textContent = '0'
      const statElement = stat.closest(this.els.stat.selector)

      if (statElement) {
        statElement.removeAttribute('data-animation-started')
      }
    })
  }

  animateStats () {
    const duration = parseInt(this.getAttribute('data-duration'), 10) || 2000
    const easeOutQuad = t => t * (2 - t)

    this.els.value.elements.forEach((stat, index) => {
      const value = parseInt(stat.getAttribute('data-value'), 10) || 0
      const delay = index * 250

      const statElement = stat.closest(this.els.stat.selector)

      setTimeout(() => {
        if (statElement) {
          statElement.setAttribute('data-animation-started', 'true')
        }

        const startTime = performance.now()

        const animate = currentTime => {
          const elapsed = currentTime - startTime
          const progress = Math.min(elapsed / duration, 1)

          stat.textContent = Math.floor(easeOutQuad(progress) * value)

          if (progress < 1) {
            requestAnimationFrame(animate)
          }
        }

        requestAnimationFrame(animate)
      }, delay)
    })
  }
}

if (!customElements.get('animated-stats')) {
  customElements.define('animated-stats', AnimatedStats)
}
